import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Textbox } from '../../models/editors/textbox.model';
import { Textarea } from '../../models/editors/textarea.model';
import { Switch } from '../../models/editors/switch.model';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { FormControlService } from '../../shared/services/form-control.service';
import { ApiService } from '../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../shared/services/alert.service';
import { Product } from '../../models/products/products.model';
import { Tags } from '../../models/editors/tags.model';
import { ContainedMany } from '../../models/editors/contained-many.model';
import { FormDetailBase } from '../../shared/components/base/form-detail/form-detail.base.component';
import { Parameters } from './../../models/editors/parameters.model';
@Component({
  selector: 'swb-product-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService],
  encapsulation: ViewEncapsulation.None
})
export class ProductDetailComponent extends FormDetailBase<Product> implements OnInit {
  private _availableCategories: any;

  public url = 'products';
  protected _redirect = './products';

  public entity = new Product({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název produktu',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'excerpt',
        label: 'Krátký popis',
        validators: [atLeastOneLang],
        isMultilang: true,
        wysiwyg: 'product-detail-excerpt'
      }),
      new Textarea({
        key: 'content',
        label: 'Celý popis',
        validators: [atLeastOneLang],
        isMultilang: true,
        wysiwyg: 'product-detail'
      }),
      new Textbox({
        key: 'parameters_title',
        label: 'Nadpis pro parametry',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'parameters_description',
        label: 'Popisek u parametrů',
        validators: [],
        isMultilang: true,
        wysiwyg: 'product-detail-param-title'
      }),
      new Textarea({
        key: 'parameters_remark',
        label: 'Poznámka u parametrů',
        validators: [],
        isMultilang: true
      }),
      new Textbox({
        key: 'title_col1',
        label: 'Nadpis 1. sloupce parametrů',
        isMultilang: true
      }),
      new Textbox({
        key: 'title_col2',
        label: 'Nadpis 2. sloupce parametrů',
        isMultilang: true
      }),
      new Textbox({
        key: 'seo_title',
        label: 'Titulek',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Parameters({
        key: 'product_parameters',
        label: 'Parametry',
        validators: []
      }),
      new Switch({
        key: 'custom_seo_data',
        label: 'Vlastní metadata',
        isMultilang: true,
        labelFalse: 'Vygenerovaná metadata'
      }),
      new Textbox({
        key: 'seo_title',
        label: 'Titulek',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Textarea({
        key: 'seo_description',
        label: 'Popisek',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Tags({
        key: 'product_categories',
        label: 'Kategorie produktů',
        entities: this._availableCategories
      }),
      new ContainedMany({
        key: 'related_products',
        label: 'Související produkty',
        entities: this.entity.related_products,
        upload: false,
        apiUrl: 'products',
        canCreate: false
      }),
      new ContainedMany({
        key: 'files',
        label: 'Galerie',
        imgOnly: false,
        upload: true,
        apiUrl: 'files'
      }),
      new ContainedMany({
        key: 'testimonials',
        label: 'Reference',
        entities: this.entity.testimonials,
        upload: false,
        apiUrl: 'testimonials',
        canCreate: true
      })
    ];
  }

  public formEditors: any;
  public isInitialized = false;
  public isSaving = false;

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getCategories('product-categories/list');

  }

  private _getCategories(uri: string) {
    this._apiService.get(uri)
      .subscribe(
        (response: any) => {
          this._availableCategories = { ...response }.data;

          this._getEntity();

        },
        (error) => console.error(error)
      );
  }

}
